import { render, staticRenderFns } from "./semesterStatistics.vue?vue&type=template&id=7fd1688e&"
import script from "./semesterStatistics.vue?vue&type=script&lang=js&"
export * from "./semesterStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports